import React from "react";

//Bold page heading with the long gold rule beside it ("About", "Artists", "Ceramics")
const PageTitle = ({ children }) => (
  <div className={"page-title container"}>
    <h1>{children}</h1>
  </div>
);

export default PageTitle;
